// fotoDistintivo.js — P3-9b (pantalla). Distintivo de una foto. «Optimizada» sale
// SOLO del REGISTRO (la foto es resultado de una optimización de Netto), que el
// backend marca en `optimizada` por foto. La deducción por nombre/tamaño se descartó:
// una foto de wp-admin con nombre SEO + JPG + ≤1600×2000 cumple las tres huellas y es
// indistinguible de una de la tubería (medido: «Rosy Lips Vaseline», 1500×1500 sin
// registro). Frontend-only → export ES.
import { esBajaResolucion } from './bajaResolucion';
//
// Distintivo — SIEMPRE uno de cuatro:
//   'baja-resolucion' → encuadrada a 4:5 no llega a 1600 de ancho (el tema no la sirve
//                       nítida en escritorio); es la señal de CALIDAD, gana sobre todo
//                       porque optimizar NO la arregla — hay que re-exportar del original;
//   'pesada'     → la vista previa la marcó candidata a optimizar;
//   'optimizada' → tiene registro de optimización (flag del backend);
//   'cumple'     → ni baja, ni candidata, ni con registro.
// Informativo: no bloquea ni cambia el criterio de optimización (una «baja-resolucion»
// que además es pesada se optimiza igual; solo se la rotula distinto).
export function distintivoFoto(prev, optimizada) {
  if (prev && prev.ok && prev.ancho && prev.alto && esBajaResolucion(prev.ancho, prev.alto)) return 'baja-resolucion';
  if (prev && prev.ok && prev.reprocesar) return 'pesada';
  if (optimizada) return 'optimizada';
  return 'cumple';
}

// Etiqueta de una fila del preview que NO se reprocesa: «ya optimizada» (tiene
// registro) o «cumple».
export function etiquetaFilaSinReproceso(optimizada) {
  return optimizada ? 'ya optimizada' : 'cumple';
}
